import RNFS from 'react-native-fs';
import { CryptEngine } from './CryptEngine';
import ReactNativeBlobUtil from 'react-native-blob-util';
const cacheDir = RNFS.DocumentDirectoryPath
export const customCachePath = `${cacheDir}/custom_cache/`

export async function findDocCachePath(url: string, mineType: string): Promise<{ url: string, isCache: boolean }> {
    const typePath = `${customCachePath}${'document'}`
    const md = CryptEngine.md5(url)
    const toFile = `${typePath}/${md}${mineType}`
    const exists = await RNFS.exists(toFile)
    if (!exists) {
        return { url: `${url}`, isCache: false }
    } else {
        return { url: toFile, isCache: true }
    }
}

export async function findCachePath(url: string, type: 'voice' | 'video'): Promise<{ url: string, isCache: boolean }> {
    const suffix = type === 'video' ? ".mp4" : ".aac"
    const typePath = `${customCachePath}${type}`
    const md = CryptEngine.md5(url)
    const toFile = `${typePath}/${md}${suffix}`
    const exists = await RNFS.exists(toFile)
    if (!exists) {
        return { url: `${url}`, isCache: false }
    } else {
        return { url: toFile, isCache: true }
    }
}

// 下载文件的函数
export const downloadFile = async (url: string, type: 'voice' | 'video'): Promise<string> => {
    const suffix = type === 'video' ? ".mp4" : ".aac"
    const typePath = `${customCachePath}${type}`
    const exists = await RNFS.exists(typePath)
    if (!exists) {
        await RNFS.mkdir(typePath)
    }
    const md = CryptEngine.md5(url)
    const toFile = `${typePath}/${md}${suffix}`
    const exists1 = await RNFS.exists(toFile)
    const downloadUrl = `${url}`
    if (exists1) {
        const statResult = await RNFS.stat(toFile);
        // 获取文件大小，单位是字节 (bytes)
        const fileSize = statResult.size;
        if (fileSize !== 0) {
            return toFile
        }
    }
    // console.log("=======download start>>>", downloadUrl)
    return ReactNativeBlobUtil
        .config({ fileCache: true, path: toFile })
        .fetch('GET', downloadUrl)
        // .then(r => r.json())
        .then(r => {
            // console.log("=======download end>>>")
            const filePath = toFile.startsWith('file://') ? toFile : 'file://' + toFile;
            return filePath
        }).catch((err) => {
            // console.log("=======download err>>>", err)
            return url
        })
};
